module.exports = __webpack_public_path__ + "img/niu6.4a2e9131.jpg";